import SEO from "../common/SEO";
import Layout from "../common/Layout";
import { seo } from "../data/seo";

const TermsAndConditions = () => {
    return (
        <>
            <SEO
                title={seo.terms.title}
                description={seo.terms.description}
                ogTitle={seo.terms.ogTitle}
                ogDescription={seo.terms.ogDescription}
            />
            <Layout>
                <div className="main-content">
                    {/* Start Contact Area  */}
                    <div className="rwt-contact-area rn-section-gap">
                        <div className="container">
                            <h1>Terms And Conditions for regina-nigma.com</h1>

                            <p>Last updated: 6th of October 2023.</p>

                            <p>By accessing and using regina-nigma.com ("the Website"), you agree to comply with and be
                                bound by the following terms and conditions. If you do not agree to these terms and
                                conditions, please do not use this Website.</p>

                            <p><strong>1. Use of the Website</strong></p>
                            <p>1.1. You must be at least 13 years old to use this Website. If you are under 13, please
                                    do not use this Website.</p>
                            <p>1.2. You are responsible for ensuring that all information you provide on this Website
                                is accurate and up to date.</p>
                            <p>1.3. You agree not to use this Website for any unlawful purpose or in any way that
                                    violates applicable laws and regulations.</p>
                            <p>1.4. You agree not to engage in any activity that may disrupt or interfere with the
                                proper functioning of this Website or its servers.</p>

                            <p><strong>2. Intellectual Property</strong></p>
                            <p>2.1. All content on this Website, including but not limited to text, images,
                                    graphics, logos, and designs, is the property of Regina Nigmatullina and is protected by
                                    copyright and other intellectual property laws.</p>
                            <p>2.2. You may not reproduce, distribute, modify, or publicly display any content from this Website
                                    without the prior written consent of Regina Nigmatullina.</p>

                            <p><strong>3. User-Generated Content</strong></p>
                            <p>3.1. If you submit or upload any content to this Website, including comments, feedback,
                                or other materials, you grant Regina Nigmatullina a non-exclusive, worldwide,
                                royalty-free license to use, reproduce, modify, and publish that content for any
                                purpose.</p>
                            <p>3.2. You are solely responsible for the content you submit, and it must not violate the
                                rights of any third parties or contain any unlawful, defamatory, or offensive material.</p>

                            <p><strong>4. Privacy</strong></p>
                            <p>4.1. Your use of this Website is also governed by our Privacy Policy, which can be found
                                at <a href="/privacy-policy">Privacy Policy</a>.</p>

                            <p><strong>5. Limitation of Liability</strong></p>
                            <p>5.1. Regina Nigmatullina makes no representations or warranties regarding the accuracy,
                                    completeness, or reliability of the content on this Website. You use this
                                    Website at your own risk.</p>
                            <p>5.2. To the extent permitted by law, Regina Nigmatullina shall not be liable for any
                                direct, indirect, incidental, consequential, or punitive damages arising out of your
                                use of or inability to use this Website.</p>

                            <p><strong>6. Termination</strong></p>
                            <p>6.1. Regina Nigmatullina reserves the right to terminate or suspend your access to this
                                Website at any time, without notice, for any reason, including if you violate these
                                terms and conditions.</p>

                            <p><strong>7. Changes to the Terms and Conditions</strong></p>
                                <p>7.1. Regina Nigmatullina may update or modify these terms and conditions at any time
                                    without prior notice. The most current version will be posted on this Website
                                    with the updated date.</p>

                            <p><strong>8. Contact Information</strong></p>
                            <p>If you have any questions or concerns regarding these terms and conditions, please
                                    contact <a href="mailto:nigmatullinaregina@gmail.com">nigmatullinaregina@gmail.com</a>.</p>
                        </div>
                    </div>
                    {/* End Contact Area  */}
                </div>
            </Layout>
        </>
)
}
export default TermsAndConditions;